import React from "react";

import SortOrderSeries from "@/components/series/SortOrderSeries";

import '@/styles/order.scss'

interface Props {
  season: string | number
  
  showList: () => void
}

function Order({season}: Props) {
  return (
    <div className="order">
      <div className="app-container order__container">
        <SortOrderSeries season={season} />
      </div>
    </div>
  );
}

export default Order;
